import { render, staticRenderFns } from "./registerPayNew.vue?vue&type=template&id=7623a7c0&scoped=true&"
import script from "./registerPayNew.vue?vue&type=script&lang=js&"
export * from "./registerPayNew.vue?vue&type=script&lang=js&"
import style0 from "./registerPayNew.vue?vue&type=style&index=0&id=7623a7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623a7c0",
  null
  
)

export default component.exports